// Teacher Profile - re-uses student Profile with teacher context

import Profile from '../student/Profile';
export default Profile;
